import { render, staticRenderFns } from "./AlarmsParc.vue?vue&type=template&id=1da22306"
import script from "./AlarmsParc.vue?vue&type=script&lang=js"
export * from "./AlarmsParc.vue?vue&type=script&lang=js"
import style0 from "./AlarmsParc.vue?vue&type=style&index=0&id=1da22306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports